module.exports = __webpack_public_path__ + "img/traffic-location-icon.1d37ed4e.svg";